module.exports = __webpack_public_path__ + "static/media/sun.91fd935a.png";